import { colorsPalettes, mixins } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

export const StyledTooltipHeader = styled(FlexRow).attrs<{ "data-automation"?: string }>(() => ({
    "data-automation": "signals-tooltip-header",
}))`
    column-gap: 24px;
    justify-content: space-between;
    padding: 24px 24px 16px;

    color: ${colorsPalettes.carbon["400"]};
    border-bottom: 1px solid ${colorsPalettes.carbon["50"]};
    box-sizing: border-box;
`;

export const StyledTooltipTitle = styled(FlexRow)`
    ${mixins.setFontVariant("listSectionTitle")};

    color: currentcolor;
    text-transform: uppercase;
    white-space: nowrap;
`;

export const StyledTooltipFooter = styled(FlexRow).attrs<{ "data-automation"?: string }>(() => ({
    "data-automation": "signals-tooltip-footer",
}))`
    height: 52px;
    width: 100%;
`;

export const StyledTooltipBody = styled(FlexColumn).attrs<{ "data-automation"?: string }>(() => ({
    "data-automation": "signals-tooltip-body",
}))`
    padding: 16px 24px;
    flex-shrink: 1;
`;
